var bannerPlacement = {
  "fields": {
    "id": {
      "name": "id",
      "type": "ID",
      "readonly": 3,
      "options": null
    },
    "bannerId": {
      "name": "bannerId",
      "type": "ID",
      "readonly": false,
      "options": null
    },
    "zone": {
      "name": "zone",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "start": {
      "name": "start",
      "type": "DATETIME",
      "readonly": false,
      "options": null
    },
    "end": {
      "name": "end",
      "type": "DATETIME",
      "readonly": false,
      "options": null
    }
  },
  "attachments": [],
  "relations": {
    "name": "banner",
    "descriptor": {
      "ghost": "Application\\Ghost\\Banner",
      "field": "bannerId"
    },
    "type": "belongsTo"
  }
};
export default bannerPlacement;